import './App.css';
import MainBackground from './components/MainBackground';
import TestimonialsAllCard from './components/TestimonialsAllCard';

function App() {
  return (
    <MainBackground>
      <TestimonialsAllCard/>
    </MainBackground>
  );
}

export default App;
